import { createTheme } from "@mui/material/styles";
import { grey } from "@mui/material/colors";

export const DialogTheme = ({ palette, breakpoints }) =>
    createTheme({
        palette,
        typography: {
            body1: {
                color: palette.text.main
            },
            body2: {
                color: palette.text.main
            },
            link: {
                color: palette.primary.main,
                cursor: "pointer",
                fontSize: "14px",
                ":hover": {
                    textDecoration: "underline"
                }
            },
            disabled: {
                color: palette.text.disabled
            }
        },
        components: {
            MuiDialog: {
                styleOverrides: {
                    root: {
                        zIndex: "1300",
                        [breakpoints.down("md")]: {
                            zIndex: "1000"
                        }
                    },
                    paper: {
                        position: "absolute",
                        margin: "36px",
                        [breakpoints.up("md")]: {
                            maxHeight: "calc(100vh - 72px)"
                        },
                        [breakpoints.down("sm")]: {
                            maxHeight: "calc(100vh - 200px)"
                        }
                    },
                    paperFullScreen: {
                        paddingTop: "55px",
                        paddingBottom: "77px"
                    },
                    paperWidthXl: {
                        width: "900px",
                        maxWidth: "900px",
                        [breakpoints.up("md")]: {
                            minWidth: "900px"
                        }
                    },
                    paperWidthLg: {
                        maxWidth: "750px",
                        [breakpoints.up("md")]: {
                            minWidth: "750px"
                        }
                    },
                    paperWidthMd: {
                        maxWidth: "600px",
                        [breakpoints.up("md")]: {
                            minWidth: "600px"
                        }
                    },
                    paperWidthSm: {
                        maxWidth: "450px",
                        [breakpoints.up("md")]: {
                            minWidth: "450px"
                        }
                    }
                }
            },
            MuiDialogTitle: {
                styleOverrides: {
                    root: {
                        color: "black",
                        variant: "h4",
                        padding: "36px",
                        fontSize: "24px",
                        fontWeight: "400",
                        lineHeight: "18px",
                        display: "flex",
                        alignItems: "center",
                        variants: [
                            {
                                props: { variant: "confirmationOrWarning" },
                                style: { paddingBottom: "24px", gap: "10px" }
                            }
                        ],
                        [breakpoints.down("md")]: {
                            padding: "18px 18px 18px 18px"
                        }
                    }
                }
            },
            MuiDialogContent: {
                styleOverrides: {
                    root: {
                        padding: "0px 36px",
                        overflowX: "hidden",
                        overflowY: "auto",
                        [breakpoints.down("md")]: {
                            padding: "0px 18px 0px 18px"
                        }
                    }
                }
            },
            MuiDialogContentText: {
                styleOverrides: {
                    root: {
                        color: palette.text.main
                    }
                }
            },
            MuiGrid: {
                styleOverrides: {
                    root: {
                        verticalAlign: "middle",
                        alignItems: "center",
                        marginTop: "0px",
                        variants: [
                            {
                                props: { variant: "subHeading" },
                                style: {
                                    lineHeight: "12px",
                                    paddingTop: "36px !important"
                                }
                            },
                            {
                                props: { variant: "subHeading-divider" },
                                style: {
                                    width: "100% !important",
                                    padding: "4px 0px 10px 18px !important"
                                }
                            },
                            {
                                props: { variant: "dropdownDivider" },
                                style: {
                                    width: "100% !important",
                                    padding: " 0px !important",
                                    margin: "0px !important"
                                }
                            },
                            {
                                props: { variant: "errorTextContainer" },
                                style: {
                                    lineHeight: "12px",
                                    paddingTop: "3px !important"
                                }
                            },
                            {
                                props: { variant: "errorTextSecondContainer" },
                                style: {
                                    lineHeight: "12px",
                                    paddingTop: "3px !important",
                                    paddingLeft: "10px !important"
                                }
                            },
                            {
                                props: { variant: "linearProgress" },
                                style: {
                                    paddingTop: "18px !important"
                                }
                            },
                            {
                                props: { variant: "repeatingSetup" },
                                style: {
                                    display: "flex",
                                    alignContent: "flex-start",
                                    gap: "18px",
                                    marginTop: "31px",
                                    maxWidth: "100%",
                                    "& .MuiGrid-root": {
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        margin: "0px"
                                    },
                                    "& .MuiStack-root": {
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        gap: "12.3px",
                                        maxWidth: "100%",
                                        height: "36px",
                                        margin: "0px",
                                        "& .MuiFormControl-root": {
                                            margin: "0px",
                                            maxWidth: "104px",
                                            minWidth: "67px"
                                        },
                                        "& .MuiInputBase-root": {
                                            padding: "7.95px 10px",
                                            margin: "0px",
                                            color: palette.text.main,

                                            "& .MuiSelect-select": {
                                                paddingRight: "0px"
                                            }
                                        },
                                        "& .MuiGrid-root": {
                                            width: "317px",
                                            justifyContent: "space-between"
                                        },
                                        "& .MuiRadio-root": {
                                            padding: "0px 2px 0px 0px",
                                            "& .MuiSvgIcon-root": {
                                                width: "1.1rem",
                                                height: "1.1rem"
                                            }
                                        },
                                        "& .MuiFormControlLabel-root": {
                                            margin: "0px"
                                        },
                                        "& .MuiTypography-root": {
                                            whiteSpace: "nowrap",
                                            color: palette.text.main,
                                            margin: "0px"
                                        }
                                    },
                                    "& .MuiFormGroup-root": {
                                        justifyContent: "space-between",
                                        maxWidth: "100%",
                                        marginLeft: "0px"
                                    }
                                }
                            }
                        ]
                    }
                }
            },
            MuiCalendarPicker: {
                styleOverrides: {
                    root: {
                        variants: [
                            {
                                props: { variant: "rescheduleModal" },
                                style: {
                                    maxWidth: "255px !important",
                                    margin: "0px !important",
                                    color: palette.text.main,
                                    "& .MuiPickersCalendarHeader-root": {
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        padding: "0px !important",
                                        margin: "0px !important"
                                    },
                                    "& .MuiPickerStaticWrapper-root": {
                                        margin: "0px !important"
                                    },
                                    "& .MuiPickerStaticWrapper-content": {
                                        margin: "0px !important"
                                    },
                                    "& .PrivatePickersSlideTransition-root": {
                                        minHeight: "214px",
                                        marginBottom: 0,
                                        overflow: "hidden"
                                    },
                                    "& .MuiPickersDay-root": {
                                        margin: "0px",
                                        height: "36px",
                                        width: "36px",
                                        color: palette.text.main
                                    },
                                    "& .MuiDayPicker-weekContainer": {
                                        margin: "0px"
                                    }
                                }
                            }
                        ]
                    }
                }
            },
            MuiDialogActions: {
                styleOverrides: {
                    root: {
                        padding: "36px",
                        "& .MuiButton-outlined": {
                            borderColor: palette.primary.main,
                            "&:hover": {
                                backgroundColor: "transparent"
                            }
                        },
                        "& .MuiButton-text": {
                            "&:hover": {
                                backgroundColor: "transparent !important"
                            }
                        },
                        variants: [
                            {
                                props: { variant: "confirmationOrWarning" },
                                style: { paddingTop: "24px" }
                            }
                        ]
                    }
                }
            },
            MuiTextField: {
                styleOverrides: {
                    root: {
                        width: "100%"
                    }
                }
            },
            MuiFormLabel: {
                styleOverrides: {
                    root: {
                        fontSize: "14px",
                        transform: "translate(14px, 8px) scale(1)",
                        "&.Mui-focused": {
                            top: "2px"
                        },
                        "&.MuiInputLabel-shrink": {
                            top: "2px"
                        }
                    },
                    normal: {
                        fontSize: "14px",
                        transform: "translate(14px, 8px) scale(1)",
                        "&.Mui-focused": {
                            top: "2px"
                        },
                        "&.MuiInputLabel-shrink": {
                            top: "2px",
                            transform: "translate(14px, -8px) scale(1)"
                        }
                    }
                }
            },
            MuiInputBase: {
                styleOverrides: {
                    root: {
                        padding: "7.95px 14px",
                        fontSize: "14px",
                        color: palette.text.main,
                        "&:hover fieldset": {
                            borderColor: `${palette.inputBorder.main} !important`
                        },
                        "&.Mui-focused fieldset": {
                            borderColor: `${palette.primary.main} !important`
                        },
                        "&.Mui-error": {
                            // Override focused border color if there's an error
                            "&.Mui-focused fieldset": {
                                borderColor: `${palette.error.main} !important`
                            }
                        }
                    },
                    input: {
                        height: "20.13px"
                    },
                    multiline: {
                        padding: "8.5px 14px !important"
                    }
                }
            },
            MuiAutocomplete: {
                styleOverrides: {
                    inputRoot: {
                        height: "36px"
                    },
                    option: {
                        fontSize: "14px"
                    },
                    popupIndicator: {
                        marginRight: "-4px",
                        "&:hover": {
                            backgroundColor: "transparent"
                        }
                    }
                }
            },
            MuiOutlinedInput: {
                styleOverrides: {
                    input: {
                        padding: "0px"
                    }
                }
            },
            MuiFormHelperText: {
                styleOverrides: {
                    root: {
                        margin: "3px 0px 0px 0px"
                    }
                }
            },
            MuiTypography: {
                styleOverrides: {
                    root: {
                        fontSize: "14px",
                        lineHeight: "20.13px"
                    },
                    h3: {
                        fontSize: "24px",
                        fontWeight: "400",
                        lineHeight: "38px",
                        color: "black"
                    },
                    h4: {
                        fontSize: "34px"
                    },
                    helperText: {
                        fontSize: "0.75rem",
                        fontWeight: "normal",
                        letterSpacing: "normal",
                        color: palette.helperText.main,
                        fontStyle: "italic",
                        fontFamily: ["Roboto", "sans-serif"].join(",")
                    },
                    errorText: {
                        fontSize: "0.75rem",
                        fontWeight: "normal",
                        color: palette.error.main,
                        lineHeight: "17px"
                    },
                    smallTitle: {
                        fontSize: "24px",
                        fontWeight: "400",
                        lineHeight: "18px",
                        color: "black",
                        [breakpoints.down("md")]: {
                            fontSize: "20px",
                            lineHeight: "16px"
                        }
                    },
                    largerSubHeading: {
                        color: palette.text.main,
                        fontSize: "18px"
                    },
                    subHeading: {
                        color: palette.helperText.main,
                        fontWeight: "700",
                        fontSize: "12px"
                    }
                }
            },
            MuiFormControlLabel: {
                styleOverrides: {
                    root: {
                        marginBottom: "0px",
                        marginRight: "12px"
                    },
                    label: {
                        fontSize: "14px"
                    },
                    labelPlacementEnd: {
                        height: "14px"
                    }
                }
            },
            MuiTooltip: {
                styleOverrides: {
                    tooltip: {
                        fontWeight: 400,
                        fontSize: "14px",
                        margin: "2px !important",
                        "& .MuiStack-root": {
                            display: "flex",
                            flexDirection: "column",
                            gap: "0px"
                        },
                        "& .MuiTypography-root": {
                            color: "white"
                        }
                    }
                }
            },
            MuiButton: {
                defaultProps: {
                    disableElevation: true
                },
                styleOverrides: {
                    root: {
                        fontWeight: 700,
                        height: "36px",
                        minWidth: "90px",
                        lineHeight: "28px",
                        "&.Mui-disabled": {
                            borderColor: `${palette.text.disabled} !important`
                        },
                        "&.MuiButton-text": {
                            "&:hover": {
                                backgroundColor: "transparent !important"
                            }
                        },
                        variants: [
                            {
                                props: { variant: "text" },
                                style: {
                                    height: "14px !important",
                                    "&.Mui-disabled": {
                                        color: palette.text.disabled,
                                        borderColor: palette.text.disabled
                                    }
                                }
                            },
                            {
                                props: { variant: "cancelButton" },
                                style: {
                                    color: palette.primary.main,
                                    border: `1px solid ${palette.primary.main}`,
                                    "&:hover": {
                                        backgroundColor:
                                            palette.primary.veryLight
                                    },
                                    "&.Mui-disabled": {
                                        border: `1px solid ${palette.text.disabled}`
                                    }
                                }
                            },
                            {
                                props: { variant: "contained" },
                                style: {
                                    "&.Mui-disabled": {
                                        color: "white"
                                    }
                                }
                            }
                        ]
                    },
                    text: {
                        display: "flex",
                        minWidth: "64px",
                        lineHeight: "16px",
                        padding: "0px",
                        alignItems: "center",
                        height: "24px"
                    },
                    contained: {
                        color: "white",
                        "&.Mui-disabled": {
                            color: "white"
                        }
                    }
                }
            },
            MuiChip: {
                styleOverrides: {
                    root: {
                        borderRadius: "16px",
                        height: "auto",
                        width: "180px",
                        fontWeight: 700,
                        backgroundColor: palette.grey.lightest,
                        color: grey[700],
                        "&:hover": {
                            backgroundColor: palette.primary.medium
                        },
                        "&:focus": {
                            backgroundColor: palette.primary.main,
                            color: "white",
                            "& .MuiTypography-helperText": {
                                color: "white"
                            },
                            "& .MuiTypography-body2": {
                                color: "white"
                            }
                        },
                        label: {
                            display: "block",
                            whiteSpace: "normal"
                        }
                    },
                    smallTimeSuggestions: {
                        width: "73px",
                        height: "21px",
                        "& .MuiChip-label": {
                            paddingLeft: "7px",
                            paddingRight: "7px"
                        }
                    },
                    emailLabel: {
                        fontWeight: 400,
                        width: "fit-content"
                    }
                }
            },
            MuiTab: {
                styleOverrides: {
                    root: {
                        padding: "18px 18px 16px 18px"
                    }
                }
            },
            MuiTableContainer: {
                styleOverrides: {
                    root: {
                        boxShadow: "none"
                    }
                }
            },
            MuiTableHead: {
                styleOverrides: {
                    root: {
                        height: "56px",
                        background:
                            "linear-gradient(0deg, rgba(255, 255, 255, 0.75), rgba(255, 255, 255, 0.75)), #D3DAE3"
                    }
                }
            },
            MuiTableCell: {
                styleOverrides: {
                    root: {
                        lineHeight: "20px",
                        verticalAlign: "middle",
                        padding: "7px 9px",
                        "&:first-child": {
                            padding: "7px 9px 7px 18px"
                        },
                        "&:last-child": {
                            padding: "7px 18px 7px 9px"
                        }
                    },
                    head: {
                        fontWeight: 700
                    }
                }
            },
            MuiTableRow: {
                styleOverrides: {
                    root: {
                        height: "56px",
                        "&.MuiTableRow-hover:hover": {
                            backgroundColor: palette.primary.light,
                            cursor: "pointer"
                        }
                    }
                }
            },
            MuiPopover: {
                styleOverrides: {
                    paper: {
                        maxWidth: "256px !important"
                    }
                }
            },
            MuiList: {
                styleOverrides: {
                    root: {
                        padding: "0px",
                        verticalAlign: "middle"
                    }
                }
            },
            MuiListItem: {
                styleOverrides: {
                    root: {
                        alignItems: "center",
                        padding: "0px 0px 0px 12px",
                        gap: "0.5rem"
                    }
                }
            },
            MuiMenu: {
                styleOverrides: {
                    paper: {
                        maxHeight: "350px",
                        maxWidth: "678px"
                    }
                }
            },
            MuiMenuItem: {
                styleOverrides: {
                    root: {
                        fontSize: "14px",
                        height: "33px",
                        lineHeight: "33px",
                        padding: "0px 18px",
                        textOverflow: "ellipsis",
                        verticalAlign: "middle"
                    }
                }
            },
            MuiCheckbox: {
                styleOverrides: {
                    root: {
                        padding: "0px 18px 0px 0px"
                    }
                }
            },
            MuiIconButton: {
                styleOverrides: {
                    root: {
                        "&.MuiSvgIcon-root:diabled": {
                            color: "green !important"
                        }
                    }
                }
            },
            MuiSvgIcon: {
                styleOverrides: {
                    root: {
                        "&.Mui-disabled": {
                            color: palette.helperText.main
                        },
                        root: {
                            color: palette.primary.main,
                            fontSize: "1rem",
                            ":disabled": {
                                color: palette.helperText.main
                            }
                        },
                        checkbox: {
                            height: "18px",
                            width: "18px",
                            marginRight: "10px"
                        },
                        variants: [
                            {
                                props: { variant: "deleteIcon" },
                                style: {
                                    translate: "4px",
                                    color: palette.helperText.main,
                                    height: "21px",
                                    width: "21px",
                                    ":hover": {
                                        color: palette.warning.main,
                                        cursor: "pointer"
                                    }
                                }
                            }
                        ]
                    }
                }
            },
            MuiCard: {
                styleOverrides: {
                    root: {
                        borderColor: palette.helperText.main
                    }
                }
            },
            MuiCardContent: {
                styleOverrides: {
                    root: {
                        display: "flex",
                        flexDirection: "column",
                        gap: "18px",
                        padding: "18px"
                    }
                }
            },
            MuiCardActions: {
                styleOverrides: {
                    root: {
                        padding: "0px 18px 18px 18px"
                    }
                }
            },
            MuiStack: {
                styleOverrides: {
                    root: {
                        flexDirection: "row",
                        justifyContent: "space-between",
                        gap: "18px"
                    }
                }
            },
            MuiSkeleton: {
                styleOverrides: {
                    root: {
                        transform: "scale(1, 0.8)",
                        backgroundColor: "rgb(0,0,0,0.08)"
                    }
                }
            },
            MuiAlert: {
                styleOverrides: {
                    root: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "6px 16px",
                        marginBottom: "24px",
                        color: palette.primary.main,
                        textAlign: "center"
                    },
                    infoAlert: {
                        height: "80px",
                        width: "100%",
                        margin: "0px",
                        textAlign: "start",
                        border: `1px solid ${palette.info.main}`,
                        color: palette.info.main,
                        backgroundColor: palette.info.light
                    },
                    recurringBookingAlert: {
                        height: "46px",
                        width: "100%",
                        margin: "0px",
                        color: palette.primary.main,
                        backgroundColor: palette.primary.light
                    }
                }
            },
            MuiInputAdornment: {
                styleOverrides: {
                    root: {
                        color: palette.grey.medium
                    }
                }
            }
        }
    });
